import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@/lib/stores/store';

export const JWT_KEY = '__dex_web_wallets';
export const JWT_KEY1 = '__dex_web_walletsTotalValue';
// export const STORAGE_KEY_NAME = '__pumpx_session_token';
export const getJwtWallets = (type: string) => {
  try {
    let result;
    result = global.localStorage.getItem(type) || '';
    if (type == '__dex_web_wallets') {
      return JSON.parse(result) ?? [];
    } else {
      return result || '';
    }
  } catch {
    return undefined;
  }
};

export async function storeSession(args: {
  type: string;
  jwt: string;
}): Promise<void> {
  if (args.jwt) {
    global.localStorage.setItem(JWT_KEY, args.jwt);
    return;
  } else {
    throw new Error('error');
  }
}

export type userWalletsItem = {
  chainId: number;
  isUsing: number;
  tokenValue: number;
  transferInRemark: string;
  txAmount: string;
  userId: number;
  userWalletAddress: string;
  walletGroupId: number;
  walletId: number;
  walletTag: string;
};

export type WalletListItem = {
  isUsing: number;
  wallGroupValues: number;
  userWallets: userWalletsItem[];
  walletGroupId: number;
};

export type HistoryTotalTokenValueProps = {
  currentTotalTokenValue: string;
  timeStamp: string;
};

export type TokenAssetsProps = {
  chainId: string;
  change24h: string;
  tokenAmount: string;
  tokenCa: string;
  tokenDecimals: string;
  tokenIcon: string;
  tokenName: string;
  tokenPrice: string;
  tokenSymbol: string;
  tokenValue: string;
  minWithdrawAmount: string;
  profitValue?: '';
  profitRange?: '';
};

export interface AccountFundResponse {
  historyTotalTokenValue: Array<HistoryTotalTokenValueProps>;
  pageNo: number;
  profitRange: string;
  profitValue: string;
  total: number;
  totalTokenValue: string;
  tokenAssets: Array<TokenAssetsProps>;
}

type DataState = {
  totalValue: string;
  wallets?: WalletListItem[];
  walletId: string | number;
  userWalletAddress: string;
  fundToken: AccountFundResponse;
};

const dataInitState: DataState = {
  totalValue: getJwtWallets(JWT_KEY1),
  wallets: getJwtWallets(JWT_KEY),
  walletId: '',
  userWalletAddress: '',
  fundToken: {
    historyTotalTokenValue: [],
    pageNo: 1,
    profitRange: '',
    profitValue: '',
    total: 0,
    totalTokenValue: '',
    tokenAssets: [],
  },
};

const walletSlice = createSlice({
  name: 'data',
  initialState: dataInitState,
  reducers: {
    setWalletTotal: (state, action: { payload: string }) => {
      storeSession({ type: JWT_KEY1, jwt: action.payload || '' });
      state.totalValue = action.payload;
    },
    setWalletsList: (state, action: { payload: WalletListItem[] }) => {
      storeSession({
        type: JWT_KEY,
        jwt: JSON.stringify(action.payload) || '',
      });
      state.wallets = action.payload;
    },
    setWalletId: (state, action: { payload: string | number }) => {
      state.walletId = action.payload;
    },
    setUserWalletAddress: (state, action: { payload: string }) => {
      state.userWalletAddress = action.payload;
    },
    setFundToken: (state, action: { payload: AccountFundResponse }) => {
      state.fundToken = action.payload;
    },
  },
});

export const reduxWalletsList = (state: RootState) => state.wallet.wallets;
export const reduxWalletsId = (state: RootState) => state.wallet.walletId;
export const reduxFundToken = (state: RootState) => state.wallet.fundToken;
export const reduxUserWalletAddress = (state: RootState) =>
  state.wallet.userWalletAddress;

export const {
  setWalletsList,
  setWalletId,
  setUserWalletAddress,
  setFundToken,
} = walletSlice.actions;
export default walletSlice.reducer;
